import React from 'react';

/**
 * The three step icons on the Angreskjema page (envelope, form, parcel),
 * drawn like the site's other line icons (see IconStore): a 16×16 grid, line
 * weight 1.2, rounded ends. The lines are strokes, so fill is switched off
 * inline: the global `svg { fill: currentColor }` rule would otherwise fill
 * the shapes.
 */
const LineIcon = ({ className, children }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    role="presentation"
    aria-hidden="true"
  >
    <g
      style={{ fill: 'none' }}
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {children}
    </g>
  </svg>
);

/** Step 1: tell the shop, by email. */
export const IconEnvelope = ({ className }) => (
  <LineIcon className={className}>
    <rect x="1.6" y="3.4" width="12.8" height="9.2" rx="1" />
    <path d="m2 4 6 4.6L14 4" />
  </LineIcon>
);

/** Step 2: the form goes in the parcel. */
export const IconDocument = ({ className }) => (
  <LineIcon className={className}>
    <path d="M9.6 1.6H4.2a1 1 0 0 0-1 1v10.8a1 1 0 0 0 1 1h7.6a1 1 0 0 0 1-1V4.8Z" />
    <path d="M9.6 1.6v3.2h3.2" />
    <path d="M5.6 8h4.8M5.6 10.6h4.8M5.6 5.4h1.8" />
  </LineIcon>
);

/** Step 3: send the parcel. */
export const IconBox = ({ className }) => (
  <LineIcon className={className}>
    <path d="M8 1.6 14 4.4v7.2L8 14.4 2 11.6V4.4Z" />
    <path d="M2 4.4 8 7.2l6-2.8M8 7.2v7.2" />
    <path d="m5 3 6 2.8v2.4" />
  </LineIcon>
);
